<template>
  <lib-section-desc :content="content" title="O systemie c-KOB" />
</template>

<script>
const code = "main";

import LibSectionDesc from "./LibSectionDesc.vue";
export default {
  name: "LibHomeSectionDesc",
  components: { LibSectionDesc },
  data: () => {
    return { content: null };
  },
  created() {
    this.loadContent();
  },
  methods: {
    loadContent() {
      this.content = this.$store.getters["layout/getPage"](code);
      if (this.content) return;
      this.$store.commit("layout/showOverlay");
      this.$axios
        .get(`/configurations/pages/${code}`)
        .then(({ data }) => {
          this.content = data.content;
          this.$store.commit("layout/setPage", {
            code: code,
            html: data.content
          });
        })
        .catch((e) => {
          console.log(e.response);
          this.$store.commit(
            "layout/showErrorDialog",
            this.getMessageMixin("getDataError")
          );
        })
        .finally(() => {
          this.$store.commit("layout/hideOverlay");
        });
    }
  }
};
</script>
